import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import SEO from '@/components/common/SEO';
import MapleMarketLibraryView from '@/components/maple-market/MapleMarketLibraryView';
import type { MapleMarketCategory } from '@/data/mapleMarketApps';
import type { MapleMarketInfoPageId } from '@/components/maple-market/MapleMarketInfoView';

export default function MapleMarketLibrary() {
  const navigate = useNavigate();
  const { appId } = useParams<{ appId?: string }>();

  useEffect(() => {
    const root = document.documentElement;
    root.classList.add('allow-window-scroll');
    return () => {
      root.classList.remove('allow-window-scroll');
    };
  }, []);

  const handleCategoryChange = (category: MapleMarketCategory | 'All') => {
    navigate(category === 'All' ? '/market' : `/market?category=${encodeURIComponent(category)}`);
  };

  const handleOpenPage = (page: MapleMarketInfoPageId) => {
    navigate(`/market?page=${encodeURIComponent(page)}`);
  };

  return (
    <>
      <SEO
        title="Library — Maple Market"
        description="Browse your Maple Market library, install apps, and open what you already own on MapleOS."
      />
      <MapleMarketLibraryView
        appId={appId}
        onOpenPage={handleOpenPage}
        onSelectCategory={handleCategoryChange}
      />
    </>
  );
}
